// import { normalizeSort } from '../utils'
import EquipmentService from '../services/EquipmentService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['name'],
    sortDesc: [false]
  }
})

const getters = {
  EQUIPAMIENTOS: state => {
    return state.list
  },
  EQUIPAMIENTOS_PAG: state => {
    return state.pagination
  }
}

const mutations = {
  SET_EQUIPAMIENTOS: (state, payload) => {
    state.list = payload
  },
  SET_EQUIPAMIENTOS_PAG: (state, payload) => {
    state.pagination = payload
  },
  DELETE_EQUIPAMIENTO: (state, payload) => {
    payload.status = 0
    payload.status_description = 'Deshabilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ADD_EQUIPAMIENTO: (state, payload) => {
    state.list.push(payload)
  },
  UPDATE_EQUIPAMIENTO: (state, payload) => {
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_EQUIPAMIENTOS: async ({ commit, state }, filter) => {
    try {
      // let pagination = {
      //   'page': state.pagination.page,
      //   'per-page': state.pagination.itemsPerPage,
      //   'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc)
      // }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }

      let { data, status } = await EquipmentService.getEquipment({ ...currentFilter })
      if (status === 200) {
        // La respuesta tiene la estructura: { data: { data: [...equipamientos] } }
        const equipamientos = data.data?.data || data.data || []
        commit('SET_EQUIPAMIENTOS', equipamientos)
        return data._meta?.totalCount || equipamientos.length
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de Equipamientos')
      console.error(error)
    }
  },
  VIEW_EQUIPAMIENTO: async ({ commit }, id) => {
    try {
      let { data, status } = await EquipmentService.view(id)
      if (status === 200) {
        // Manejar la estructura de respuesta que puede ser anidada
        return data.data || data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar obtener los detalles del equipamiento')
      throw error
    }
  },
  ADD_EQUIPAMIENTO: async ({ commit }, payload) => {
    try {
      let { data, status } = await EquipmentService.post(payload)
      if (status === 200 || status === 201) {
        // Manejar la estructura de respuesta que puede ser anidada
        const equipamientoData = data.data || data
        commit('ADD_EQUIPAMIENTO', equipamientoData)
        window.app.$toast.success('El equipamiento ha sido registrado satisfactoriamente')
        return { error: false, data: equipamientoData, status }
      } else {
        return { error: true, data: data, status }
      }
    } catch (error) {
      return { error: true, data: error.response?.data || error.message, status: error.response?.status || 500 }
    }
  },
  UPDATE_EQUIPAMIENTO: async ({ commit }, payload) => {
    try {
      let { data, status } = await EquipmentService.put(payload)
      if (status === 200) {
        // Manejar la estructura de respuesta que puede ser anidada
        const equipamientoData = data.data || data
        commit('UPDATE_EQUIPAMIENTO', equipamientoData)
        window.app.$toast.success('El equipamiento ha sido actualizado satisfactoriamente')
        return { error: false, data: equipamientoData, status }
      } else {
        return { error: true, data: data, status }
      }
    } catch (error) {
      return { error: true, data: error.response?.data || error.message, status: error.response?.status || 500 }
    }
  },
  DELETE_EQUIPAMIENTO: async ({ commit }, payload) => {
    try {
      let { status } = await EquipmentService.delete(payload)
      if (status === 204) {
        commit('DELETE_EQUIPAMIENTO', payload)
        window.app.$toast.success('El equipamiento ha sido deshabilitado satisfactoriamente')
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar deshabilitar el equipamiento')
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
